import { render, staticRenderFns } from "./formSelectCapital.vue?vue&type=template&id=774ed9b2&scoped=true"
import script from "./formSelectCapital.vue?vue&type=script&lang=js"
export * from "./formSelectCapital.vue?vue&type=script&lang=js"
import style0 from "./formSelectCapital.vue?vue&type=style&index=0&id=774ed9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ed9b2",
  null
  
)

export default component.exports